import { moduleBorderBottom } from '@/helpers/environmentHelper';
import { useAppDispatch } from '@/state/hooks';
import { setIsDragging } from '@/state/reducers/mosaicSlice';
import { useScreenSizes } from '@/utils/providers/ScreenSizesProvider';
import cn from 'classnames';
import { useCallback } from 'react';
import { isTablet } from 'react-device-detect';
import { MosaicWindow } from 'react-mosaic-component';

export const moduleHeaderClassName = cn(
    'flex justify-between items-center w-full h-full text-brand-module-title',
    moduleBorderBottom
);

const ModuleWindow = ({ id, path, tradingModule, renderToolbar, children }: any) => {
    const dispatch = useAppDispatch();

    const screen = useScreenSizes();

    const dragStart = useCallback(() => {
        dispatch(setIsDragging(true));
    }, []);

    const dragEnd = useCallback(() => {
        dispatch(setIsDragging(false));
    }, []);

    return (
        <div id={id}>
            <MosaicWindow<string>
                path={path}
                title={tradingModule?.title}
                draggable={(screen.laptop || screen.desktop) && !isTablet}
                onDragStart={dragStart}
                onDragEnd={dragEnd}
                renderToolbar={renderToolbar}>
                {children}
            </MosaicWindow>
        </div>
    );
};

export default ModuleWindow;

export function launchFullscreen(elem = document.documentElement as any) {
    const windowe = window as any;
    const documente = document as any;
    const { screen } = window;
    if (
        windowe.fullScreen ||
        documente?.webkitIsFullScreen ||
        elem.fullscreenElement ||
        document?.fullscreenElement ||
        (window.innerWidth === screen.width && window.innerHeight === screen.height)
    ) {
        return exitFullscreen();
    }
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
    } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
    } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
    }
}

export function exitFullscreen(elem = document.documentElement as any) {
    const windowe = window as any;

    if (document?.exitFullscreen) {
        document?.exitFullscreen();
    } else if (windowe?.webkitExitFullscreen) {
        windowe?.webkitExitFullscreen();
    } else if (windowe?.mozCancelFullScreen) {
        windowe?.mozCancelFullScreen();
    } else if (elem.exitFullscreen) {
        elem.exitFullscreen();
    } else if (elem.mozCancelFullScreen) {
        elem.mozCancelFullScreen();
    } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen();
    } else if (elem.webkitExitFullScreen) {
        elem.webkitExitFullScreen();
    } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen();
    }
}
